import { render, staticRenderFns } from "./ContratoSustitucion.vue?vue&type=template&id=42902371&"
import script from "./ContratoSustitucion.vue?vue&type=script&lang=js&"
export * from "./ContratoSustitucion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports